module.exports = __webpack_public_path__ + "static/img/5.245faa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zz/5.png
// module id = Y2H+
// module chunks = 1